import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import NewRequestCard from "../../../../components/requests/NewRequestCard";
import OutGoingRequestCard from "../../../../components/requests/OutGoingRequestCard";
import { makeApiRequest } from "../../../../helpers";
import RequestsModel from "../../../../api/models/RequestsModel";
import { updateApologizeRequests } from "../../../../api/endpoints/tutors/requests";
import { ApiResponse } from "../../../../api/apiResponse";
import { ToastContext } from "../../../../App";

type ReceivedTabProps = {
  requests: RequestsModel[];
  requestsNotPending: RequestsModel[];
};
export const ReceivedTab = (props: ReceivedTabProps) => {
  const LocalBasePath = "page.tutor.dashboard.requests";
  const { requests, requestsNotPending } = props;
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const toast = useContext(ToastContext);

  const changeRequestStatus = (accept: boolean, id: string | number) => {
    if (accept) {
      makeApiRequest(
        () => updateApologizeRequests(id, { status: "approved" }),
        (response: ApiResponse) => {
          if (response.isSuccess) {
            toast?.success(t("savedSuccessfully"));
            window.location.reload();
          } else {
            response.errorMessages.forEach((errorMessage) => {
              toast?.error(errorMessage);
            });
          }
        }
      );
    } else {
      makeApiRequest(
        () => updateApologizeRequests(id, { status: "rejected" }),
        (response: ApiResponse) => {
          if (response.isSuccess) {
            toast?.success(t("savedSuccessfully"));
            window.location.reload();
          } else {
            response.errorMessages.forEach((errorMessage) => {
              toast?.error(errorMessage);
            });
          }
        }
      );
    }
  };

  return (
    <div className="flex flex-col w-full gap-6 px-8 py-6 bg-white">
      <div className="flex flex-col">
        {requests.length > 0 && (
          <>
            <div className="flex flex-col gap-3">
              {requests.map((request) => (
                <NewRequestCard
                  changeRequestStatus={changeRequestStatus}
                  request={request}
                />
              ))}
            </div>
          </>
        )}
      </div>
      <div className="flex flex-col">
        {requestsNotPending.length > 0 && (
          <>
            <div className="flex flex-col gap-3">
              {requestsNotPending.map((request) => (
                <OutGoingRequestCard request={request} />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
